import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentEvent: [],
  ticketsSold: [],
  items: {},
  cart: {
    productsCount: 0,
    subAmount: 0.0,
    subTotal: 0.0,
    total: 0.0,
    grandTotal: 0.0,
    bookingFee: 0.0,
    discount_amount: 0.0,
    discount_type: 0,
    coupon_id: null,
  },
  booking: null,
  secretCode: null,
  verifiedTicket: null,
};

export const eventSlice = createSlice({
  name: "event",
  initialState,
  reducers: {
    incrementTicket: (state, action) => {
      const id = action.payload;

      if (!state.ticketsSold[id]) {
        // initialize if it doesn't exist
        state.ticketsSold[id] = { count: 0 };
      }

      state.ticketsSold[id].count += 1;
    },

    decrementTicket: (state, action) => {
      const id = action.payload;

      if (state.ticketsSold[id] && state.ticketsSold[id].count > 0) {
        state.ticketsSold[id].count -= 1;
      }
    },

    setTickets: (state, actions) => {
      state.ticketsSold[actions.payload.id] = actions.payload;
    },
    updateEvent: (state, actions) => {
      state.currentEvent = actions.payload;
    },
    setItem: (state, actions) => {
      state.items[actions.payload.ticket_id] = actions.payload;
    },
    setCart: (state, actions) => {
      state.cart = actions.payload;
    },
    setBooking: (state, actions) => {
      state.booking = actions.payload;
    },
    resetEvent: (state) => {
      state.currentEvent = [];
      state.ticketsSold = [];
      state.booking = null;
      state.items = {};
      state.cart = {
        productsCount: 0,
        subAmount: 0.0,
        subTotal: 0.0,
        total: 0.0,
        grandTotal: 0.0,
        bookingFee: 0.0,
        discount_amount: 0.0,
        discount_type: 0,
        coupon_id: null,
      };
      state.secretCode = null;
      state.verifiedTicket = null;
    },
    resetSale: (state) => {
      state.ticketsSold = [];
      state.booking = null;
      state.items = {};
      state.cart = {
        productsCount: 0,
        subAmount: 0.0,
        subTotal: 0.0,
        total: 0.0,
        grandTotal: 0.0,
        bookingFee: 0.0,
        discount_amount: 0.0,
        discount_type: 0,
        coupon_id: null,
      };
      state.secretCode = null;
      state.verifiedTicket = null;
    },
    setSecretCode: (state, actions) => {
      state.secretCode = actions.payload;
    },
    setVerifiedTicket: (state, actions) => {
      state.verifiedTicket = actions.payload;
    },
  },
});

export const { incrementTicket, decrementTicket, updateEvent, setTickets, setItem, setCart, setBooking, resetEvent, resetSale, setSecretCode, setVerifiedTicket } = eventSlice.actions;

export default eventSlice.reducer;
